module.exports = __webpack_public_path__ + "static/media/sale_badge.21b0f602.svg";